







import Vue from 'vue';
import AccountToolbar from '@/account/AccountToolbar.vue';
import SetupAgencyMixin from '@/account/setup/agency/SetupAgencyMixin';
import AgencyTabs from '@/account/agency/AgencyTabs.vue';

export default Vue.extend({
  mixins: [SetupAgencyMixin],
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  components: {
    'account-toolbar': AccountToolbar,
    'agency-tabs': AgencyTabs,
  },
});
